import UserAvatar, { IUserAvatarProps } from './UserAvatar';
export { UserAvatar };
export type { IUserAvatarProps };
export default UserAvatar;
